import { Box, Card, Grid, Link, Typography } from '@mui/material';
import '../components/LostCargo.scss';
import { useLostCargoReturnPage } from '../context/LostCargoReturnPageContext';
import TimeHelper from '../../../utils/time';
import { useTranslation } from 'react-i18next';
import CopyToClipboardButton from '../../../atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';
import { LCSR } from '../lostCargoSearchReturnPage.classes';

function LostCargoInfoCard() {
    const { returnListData } = useLostCargoReturnPage();
    const { t } = useTranslation();
    return (
        returnListData && (
            <Card className={LCSR.infoCard} sx={{ paddingTop: 3 }}>
                <Grid className={LCSR.infoCardGrid} container spacing={1}>
                    {returnListData.customerId !== null &&
                        returnListData.customerId !== undefined &&
                        returnListData.customerId != 0 && (
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6,
                                }}
                            >
                                {/* Sol Sütun Verileri*/}
                                <Box className={LCSR.infoRow} mb={1}>
                                    <Box display="flex" alignItems="center">
                                        <Typography
                                            className={LCSR.infoLabel}
                                            variant="subtitle2"
                                            color="text.secondary"
                                            sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}
                                        >
                                            {t('lostCargoReturnPageBuilder.customerId')}:
                                        </Typography>
                                        <Typography className={LCSR.infoValue}>
                                            <Link
                                                className={LCSR.linkCustomerManagement}
                                                href={`/customerManagement?ActiveTab=OrderInformation&customerId=${returnListData.customerId}`}
                                                underline="hover"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {returnListData.customerId}
                                            </Link>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        )}
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                        }}
                    >
                        {/* Sağ Sütun Verileri */}
                        <Box className={LCSR.infoRow} mb={1}>
                            <Box display="flex" alignItems="center">
                                <Typography
                                    className={LCSR.infoLabel}
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}
                                >
                                    {t('lostCargoReturnPageBuilder.orderDate')}:
                                </Typography>
                                <Typography className={LCSR.infoValue}>{TimeHelper.formatDateHour(returnListData.orderDate)}</Typography>
                            </Box>
                        </Box>

                        <Box className={LCSR.infoRow} mb={1}>
                            <Box display="flex" alignItems="center">
                                <Typography
                                    className={LCSR.infoLabel}
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}
                                >
                                    {t('lostCargoReturnPageBuilder.shippingListNo')}:
                                </Typography>
                                <Typography className={LCSR.infoValue} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Link
                                        className={LCSR.linkShippingList}
                                        href={`/orderdetail?shippingListNo=${returnListData.shippingListForBackofficeModels[0].shippingListNo}`}
                                        underline="hover"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {returnListData.shippingListForBackofficeModels[0].shippingListNo}
                                    </Link>
                                    <CopyToClipboardButton
                                        textToCopy={returnListData.shippingListForBackofficeModels[0].shippingListNo}
                                        sx={{ ml: 1 }}
                                    />
                                </Typography>
                            </Box>
                        </Box>

                        <Box className={LCSR.infoRow} mb={1}>
                            <Box display="flex" alignItems="center">
                                <Typography
                                    className={LCSR.infoLabel}
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}
                                >
                                    {t('lostCargoReturnPageBuilder.orderId')}:
                                </Typography>
                                <Typography className={LCSR.infoValue}>
                                    <Link
                                        className={LCSR.linkOrderDetail}
                                        href={`/orderdetail?orderId=${returnListData.orderId}`}
                                        underline="hover"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {returnListData.orderId}
                                    </Link>
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Card>
        )
    );
}

export default LostCargoInfoCard;
